import _set from 'lodash/set';
import forOwn from 'lodash/forOwn';
import {localize} from 'linksoft';
const Resx = localize('DataTables');
const log = require('debug')('linksoft:datatables:language');

export default function() {
	const language = {};
	forOwn(Resx.DataTables, (v, k) => {
		const key = k.replace(/_/g, '.');
		if(v !== key) {
			_set(language, key, v)
		}
	});
	log('datatables localization: %o', language);
	return language;
};


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/language.js